/* eslint-disable */
import vm from '../main.js'
import {
  Map,
  View,
  Overlay
} from 'ol'
import {
  Tile as TileLayer,
  Vector as VectorLayer
} from 'ol/layer.js'
import TileWMS from 'ol/source/TileWMS.js'
import VectorSource from 'ol/source/Vector.js'
import Feature from "ol/Feature";
import XYZ from 'ol/source/XYZ.js'
import {
  defaults as defaultControls
} from 'ol/control.js';
import {
  WFS,
  GeoJSON
} from 'ol/format.js';
import {
  bbox as bboxStrategy
} from 'ol/loadingstrategy';
import {
  equalTo as equalToFilter
} from 'ol/format/filter.js';
import {
  Style,
  Stroke,
  Circle as CircleStyle
} from 'ol/style.js';
import Point from 'ol/geom/Point'
import {
  easeOut
} from 'ol/easing.js';
import {
  unByKey
} from 'ol/Observable.js';
import TileGrid from 'ol/tilegrid/TileGrid.js';
import {
  locateStyleCollection,
  wfsStyleFunction,
  renyuanStyleFunction,
  taskStyleFunction
} from '@/utils/MapIcons'
import {
  get as getProjection
} from 'ol/proj.js';
import {
  getWidth
} from 'ol/extent.js';
import LineString from 'ol/geom/LineString'
import iconUser from '../assets/gisicon/user.png'
import iconTaskDown from '../assets/gisicon/task_down.png'
import iconTaskUp from '../assets/gisicon/task_up.png'
import tree1 from '../assets/gisicon/tree1.png'
import tree2 from '../assets/gisicon/tree2.png'
import tree3 from '../assets/gisicon/tree3.png'
import tree4 from '../assets/gisicon/tree4.png'
import gsp from '../assets/gisicon/gsp.png'
import jcd from '../assets/gisicon/jcd.png'
import xqd from '../assets/gisicon/xqd.png'
const baseUrl = process.env.BASE_URL;
const type_googlemap = 'google'
const type_tdt = 'tdt'
const type_tdtjd = 'tdtjd'
const type_tdtzj = 'tdtzj'
const type_geoserverwfs = 'geoserverwfs'
const type_geoserverwms = 'geoserverwms'

const resolutions = new Array(22),
  extent = getProjection('EPSG:4326').getExtent()
for (var i = 0, ii = resolutions.length; i < ii; ++i) {
  resolutions[i] = getWidth(extent) / 512 / Math.pow(2, i);
}
const tile512 = new TileGrid({
  extent: extent,
  resolutions: resolutions,
  tileSize: [512, 512]
})

/**
 * 初始化地图(Web样式)
 * 默认添加一个谷歌图层，并根据gisconfig中的位置进行定位；
 * return map;
 */
export function initMap(mapid, gisConfig, option) {
  //检查gisconfig是否配置了中心点、初始比例尺，否则去默认值
  if (!gisConfig) {
    gisConfig = {};
  }
  if (gisConfig.appSite && gisConfig.appSite.centerPoint && gisConfig.appSite.centerPoint.x && gisConfig.appSite.centerPoint.y) {
    gisConfig.center = [gisConfig.appSite.centerPoint.x * 1, gisConfig.appSite.centerPoint.y * 1]
  }
  if (gisConfig.appSite && gisConfig.appSite.scale) {
    gisConfig.scale = gisConfig.appSite.scale * 1
  }
  var basemap = new TileLayer({
    source: new XYZ({
      url: 'https://t{0-7}.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=c2cf32cee5ce18c073748c727e4f8f80'
    })
  })
  basemap.dhlayertype = type_googlemap
  basemap.dhservicetype = type_googlemap
  basemap.dhlayername = '谷歌影像'
  var showZoom = false //要求默认是不显示的ZoomSlider的，除非特殊要求
  if (option) {
    showZoom = option.showZoom
  }
  //创建地图
  const map = new Map({
    target: mapid,
    loadTilesWhileInteracting: true,
    layers: [
      basemap
    ],
    controls: defaultControls({
      attribution: false,
      rotate: false,
      zoom: showZoom
    }),
    view: new View({
      projection: mapConfig.projection,
      center: gisConfig.center || mapConfig.center,
      zoom: gisConfig.scale || mapConfig.initscale,
      minZoom: mapConfig.minscale,
      maxZoom: mapConfig.maxscale,
      enableRotation: false
    })
  });
  return map;
}


/**
 * 解析gisconfig，并将图层添加到地图
 * 该方法用于处理一个按照gisconfig对象配置的图层，将不同类型的图层配置到地图中
 * 重要：如果各业务对图层有不同要求，请在调用方法前，自行修改gisconfig对象
 * hiddenLayerIds:[]，将不需要立即显示的图层id放入，例如['geo_gushu']古树图层会不显示
 * visibleLayerIds:[], 仅需要显示的图层id放入，例如['geo_gushu']古树图层才会显示，如果为空则全部显示
 * return map
 */
export function addLayerToMap(map, gisConfig, hiddenLayerIds, visibleLayerIds) {
  //监测是否有显示的政区layer，如果有责任区layer就隐藏label
  var hasVisivbleZqLayer = hasVisibleZq(gisConfig);
  // console.log(hasVisivbleZqLayer)
  if (!hiddenLayerIds) {
    hiddenLayerIds = []
  }
  if (!visibleLayerIds) {
    visibleLayerIds = []
  }
  //遍历图层组
  if (gisConfig && gisConfig.gisConfigList && gisConfig.gisConfigList.length > 0) {
    for (var i = gisConfig.gisConfigList.length - 1; i >= 0; i--) {
      var item = gisConfig.gisConfigList[i]
      //遍历图层
      if (item.subConfigList && item.subConfigList.length > 0) {
        for (var j = item.subConfigList.length - 1; j >= 0; j--) {
          var subitem = item.subConfigList[j]
          if (!subitem.scale || subitem.scale.length != 2) {
            subitem.scale = [1, 22]
          }
          let layeritem = null, //创建图层对象
            layerminscale = subitem.scale[0],
            layermaxscale = subitem.scale[1],
            layerdesc = [],
            CQL_FILTER = null,
            _v = false;
          if (!subitem.layerType) {
            subitem.layerType = subitem.serviceType
          }
          //图层配置是否默认就显示
          if (subitem.isShow === true && hiddenLayerIds.indexOf(subitem.layerType) == -1 &&
            (visibleLayerIds.length == 0 || visibleLayerIds.indexOf(subitem.layerType) > -1)) {
            _v = true
          }
          //图层如果配置了CQL，则初始化该CQL
          if (gisConfig.queryWithCQL && subitem.layerCql) {
            CQL_FILTER = subitem.layerCql
            if (gisConfig.uid) {
              CQL_FILTER = CQL_FILTER.replace('{u_id}', gisConfig.uid)
            }
            if (gisConfig.uregion) {
              if(gisConfig.uregion instanceof Array){
                let string='(';
                for(var t=0;t<gisConfig.uregion.length;t++){
                  if(t==0){
                    string=string+"'"+gisConfig.uregion[t]+"'";
                  }else{
                    string=string+",'"+gisConfig.uregion[t]+"'";
                  } 
                }
                string+=')';
                CQL_FILTER = "is_del = false and zq_code in  "+string
              }else{
                CQL_FILTER = CQL_FILTER.replace("{u_region}", gisConfig.uregion);
              }
            }
            if (gisConfig.uregionlevel) {
              CQL_FILTER = CQL_FILTER.replace('{u_region_level}', gisConfig.uregionlevel)
            }
          }
          if (subitem.layerUrl && (subitem.serviceType == type_tdt || subitem.serviceType == type_tdtjd || subitem.serviceType == type_tdtzj)) {
            layeritem = new TileLayer({
              visible: _v,
              minResolution: map.getView().getResolutionForZoom(layermaxscale),
              maxResolution: map.getView().getResolutionForZoom(layerminscale - 1),
              source: new XYZ({
                url: subitem.layerUrl
              })
            })
            layeritem.dhlayername = subitem.layerName
            layeritem.dhservicetype = subitem.serviceType
            layeritem.dhlayertype = subitem.layerType
            layeritem.dhid = subitem.id
            map.addLayer(layeritem);
          } else if (subitem.layerUrl && subitem.serviceType == type_geoserverwms) {
            layerdesc = subitem.layerUrl.split(';')
            if (layerdesc.length != 3) {
              continue
            }
            var _style = null
            //如果类型是责任区，且任意一个政区图层是默认显示的，那么责任区图层显示时不显示标注
            if (_v && hasVisivbleZqLayer && (subitem.layerType == 'geo_grid_sheng' || subitem.layerType == 'geo_grid_shi' ||
                subitem.layerType == 'geo_grid_xian' || subitem.layerType == 'geo_grid_xiang' || subitem.layerType == 'geo_grid_cun')) {
              _style = subitem.layerType + "_nolabel"
            }
            layeritem = new TileLayer({
              visible: _v,
              minResolution: map.getView().getResolutionForZoom(layermaxscale),
              maxResolution: map.getView().getResolutionForZoom(layerminscale - 1),
              source: new TileWMS({
                url: layerdesc[0] + layerdesc[1] + "/wms",
                params: {
                  'LAYERS': layerdesc[1] + ":" + layerdesc[2],
                  'TILED': true,
                  'CQL_FILTER': CQL_FILTER,
                  STYLES: _style
                },
                crossOrigin: "anonymous",
                tileGrid: tile512
              })
            });
            layeritem.dhgsurl = layerdesc[0]
            layeritem.dhgsws = layerdesc[1]
            layeritem.dhgslayer = layerdesc[2]
            layeritem.dhlayername = subitem.layerName
            layeritem.dhservicetype = subitem.serviceType
            layeritem.dhlayertype = subitem.layerType
            layeritem.dhid = subitem.id
            layeritem.dhminzoom = layerminscale
            layeritem.dhmaxzoom = layermaxscale
            layeritem.CQL_FILTER = CQL_FILTER
            map.addLayer(layeritem);
          } else if (subitem.layerUrl && subitem.serviceType == type_geoserverwfs) {
            layerdesc = subitem.layerUrl.split(';')
            if (layerdesc.length != 3) {
              continue
            }
            let CQL=CQL_FILTER?'cql_filter='+CQL_FILTER:"bbox=" +
            extent.join(",") +
            "," +
            mapConfig.projection;
            let sortByCQL=subitem.layerType=='lz_task'?'&sortBy=status':'';
            layeritem = new VectorLayer({
              visible: _v,
              minResolution: map.getView().getResolutionForZoom(layermaxscale),
              maxResolution: map.getView().getResolutionForZoom(layerminscale - 1),
              source: new VectorSource({
                format: new GeoJSON(),
                url: function (extent) {
                  return layerdesc[0] + 'wfs?service=WFS&' +
                    'version=1.1.0&request=GetFeature&typename=' + layerdesc[1] + ':' + layerdesc[2] + '&' +
                    'outputFormat=application/json&srsname=' + mapConfig.projection +("&" +CQL+sortByCQL);
                },
                strategy: bboxStrategy
              }),
              style: wfsStyleFunction
            });
            layeritem.dhgsurl = layerdesc[0]
            layeritem.dhgsws = layerdesc[1]
            layeritem.dhgslayer = layerdesc[2]
            layeritem.dhlayername = subitem.layerName
            layeritem.dhservicetype = subitem.serviceType
            layeritem.dhlayertype = subitem.layerType
            layeritem.dhid = subitem.id
            layeritem.dhminzoom = layerminscale
            layeritem.dhmaxzoom = layermaxscale
            layeritem.CQL_FILTER = CQL_FILTER?CQL:'';
            layeritem.CQL_ORIGINAL = CQL_FILTER?CQL:'';
            map.addLayer(layeritem)
          }
          // console.log(layeritem)
        }
      }
    }
  }

}
function addTask(map,subitem,type,objid){
  //属性过滤
  var layerdesc = subitem.layerUrl.split(';')
  var vectorSource = new VectorSource({crossOrigin: "anonymous",})
  var url = layerdesc[0] +"wfs";
  let  CQL_FILTER = subitem.layerCql;
  
  
  var layerminscale = subitem.scale[0],
  layermaxscale = subitem.scale[1];
  var featureRequest = new WFS().writeGetFeature({
      srsName: mapConfig.projection,//坐标系
      featureNS: layerdesc[0] +map.gisConfig.geoServerWorkspace,// 注意这个值必须为创建工作区时的命名空间URI
      featurePrefix: map.gisConfig.geoServerWorkspace,//工作区的命名
      featureTypes: [subitem.layerType],//所要访问的图层
      maxFeatures: 1,
      outputFormat: 'application/json',
      filter:equalToFilter("objid", objid) //属性过滤条件
  });
  fetch(url, {
      method: 'POST',
      body: new XMLSerializer().serializeToString(featureRequest),
  }).then(function (response) {
      return response.json();
  }).then(function (json) {
      var features = new GeoJSON().readFeatures(json);
      console.log(features.length);
      if (features.length > 0) {
          vectorSource.clear();
          vectorSource.addFeatures(features);
      }
  });
  let layeritem = new VectorLayer({
    visible: true,
    minResolution: map.getView().getResolutionForZoom(layermaxscale),
    maxResolution: map
      .getView()
      .getResolutionForZoom(layerminscale - 1),
    source: vectorSource,
    style: wfsStyleFunction,
  });
  layeritem.dhgsurl = layerdesc[0]
  layeritem.dhgsws = layerdesc[1]
  layeritem.dhgslayer = layerdesc[2]
  layeritem.dhlayername = subitem.layerName
  layeritem.dhservicetype = subitem.serviceType
  layeritem.dhlayertype = subitem.layerType
  layeritem.dhid = subitem.id
  layeritem.dhminzoom = layerminscale
  layeritem.dhmaxzoom = layermaxscale
  layeritem.CQL_FILTER = CQL_FILTER
  map.addLayer(layeritem);
}
function hasVisibleZq(gisConfig) {
  var flag = false;
  if (gisConfig && gisConfig.gisConfigList && gisConfig.gisConfigList.length > 0) {
    for (var i = gisConfig.gisConfigList.length - 1; i >= 0; i--) {
      var item = gisConfig.gisConfigList[i]
      //遍历图层
      if (item.subConfigList && item.subConfigList.length > 0) {
        for (var j = item.subConfigList.length - 1; j >= 0; j--) {
          var subitem = item.subConfigList[j]
          if (subitem.isShow == true && (subitem.layerType == 'geo_sheng' || subitem.layerType == 'geo_shi' ||
              subitem.layerType == 'geo_xian' || subitem.layerType == 'geo_xiang' || subitem.layerType == 'geo_cun')) {
            flag = true
            break
          }
        }
      }
    }
  }
  return flag;
}

//设置专门用于资源定位的图层，并添加到地图上
export function addLocateLayerToMap(map) {
  var vectorSource = new VectorSource();
  var vectorLayer = new VectorLayer({
    source: vectorSource,
    style: function (feature) {
      if (feature.dhfeaturetype == 'lz_protect_forest' && feature.getGeometry().constructor === Point) {
        return locateStyleCollection['lz_protect_forest_point_selected']
      } else if (feature.dhfeaturetype == 'lz_protect_forest' && feature.getGeometry().constructor === LineString) {
        return locateStyleCollection['lz_protect_forest_line_selected']
      }
      //人员
      if(feature.dhfeaturetype=='lz_user' || feature.dhfeaturetype=='v_lz'){
        return renyuanStyleFunction(feature)
      }
      //任务的选中定位效果
      if(feature.dhfeaturetype=='lz_task'){
        return taskStyleFunction(feature)
      }
      return locateStyleCollection[feature.dhfeaturetype + '_selected'] || locateStyleCollection['default']
    }
  })
  vectorLayer.dhservicetype = 'locatelayer'
  vectorLayer.dhlayertype = 'locatelayer'
  map.addLayer(vectorLayer);
  vectorSource.on('addfeature', function (e) {
    flash(map, e.feature);
  });
}

//设置改革示范区Layer
export function addGgsfqLayerToMap(map, gisConfig) {
  var newgisconfig = [{
    subConfigList: []
  }]
  //修改gisconfig对象，增加一个改革示范区图层，再祛除掉用不到的图层
  newgisconfig[0].subConfigList.push({
    // layerUrl:mapConfig.defaultGeoServerURL+';'+mapConfig.defaultGeoServerWorkspace+';'+'geo_demonstration_area'
    layerUrl: gisConfig.geoServerUrl + ';' + gisConfig.geoServerWorkspace + ';' + 'geo_demonstration_area',
    serviceType: type_geoserverwfs,
    layerName: '改革示范区',
    layerType: 'geo_demonstration_area',
    scale: [6, 22],
    isShow: true
  })
  if (gisConfig && gisConfig.gisConfigList && gisConfig.gisConfigList.length > 0) {
    for (var i = 0; i < gisConfig.gisConfigList.length; i++) {
      var item = gisConfig.gisConfigList[i]
      //遍历图层
      if (item.subConfigList && item.subConfigList.length > 0) {
        for (var j = 0; j < item.subConfigList.length; j++) {
          var subitem = item.subConfigList[j]
          if (subitem.serviceType == 'tdt' || subitem.layerType == 'geo_sheng' || subitem.layerType == 'geo_shi' ||
            subitem.layerType == 'geo_xian' || subitem.layerType == 'geo_xiang' || subitem.layerType == 'geo_cun') {
            subitem.isShow = true
            //subitem.layerCql = ''//取消图层过滤表达式 
            newgisconfig[0].subConfigList.push(subitem)
          }
        }
      }
    }
  }
  var layerconfig = {}
  layerconfig.uid = gisConfig.uid
  layerconfig.uregion = gisConfig.uregion
  layerconfig.uregionlevel = gisConfig.uregionlevel
  layerconfig.gisConfigList = newgisconfig
  layerconfig.queryWithCQL = gisConfig.queryWithCQL
  addLayerToMap(map, layerconfig)
}

/**
 * 添加指定级别的网格图层
 */
export function addGridLayerToMap(map, gisConfig, gridType) {
  var newgisconfig = [{
    subConfigList: []
  }]
  //修改gisconfig对象，祛除掉用不到的图层
  if (gisConfig && gisConfig.gisConfigList && gisConfig.gisConfigList.length > 0) {
    for (var i = 0; i < gisConfig.gisConfigList.length; i++) {
      var item = gisConfig.gisConfigList[i]
      //遍历图层
      if (item.subConfigList && item.subConfigList.length > 0) {
        for (var j = 0; j < item.subConfigList.length; j++) {
          var subitem = item.subConfigList[j]
          if (subitem.layerType == gridType) {
            subitem.scale = [6, 22]
            newgisconfig[0].subConfigList.push(subitem)
          }
        }
      }
    }
  }
  var layerconfig = {}
  layerconfig.uid = gisConfig.uid
  layerconfig.uregion = gisConfig.uregion
  layerconfig.uregionlevel = gisConfig.uregionlevel
  layerconfig.gisConfigList = newgisconfig
  layerconfig.queryWithCQL = gisConfig.queryWithCQL
  addLayerToMap(map, layerconfig)
}
//设置专门用于轨迹起始位置标记的图层，并添加到地图上
export function addMarkerLayerToMap(map) {
  var vectorfirstSource = new VectorSource();
  var vectorfirstLayer = new VectorLayer({
    source: vectorfirstSource,
    // style: function(feature) {
    //   return locateStyleCollection["locate_first"];
    // },
  });
  vectorfirstLayer.dhservicetype = "locatefirstlayer";
  vectorfirstLayer.dhlayertype = "locatefirstlayer";
  map.addLayer(vectorfirstLayer);
  vectorfirstSource.on("addfeature", function (e) {
    flash(map, e.feature);
  });

  var vectorlastSource = new VectorSource();
  var vectorlastLayer = new VectorLayer({
    source: vectorlastSource,
    // style: function(feature) {
    //   return locateStyleCollection["locate_last"];
    // },
  });
  vectorlastLayer.dhservicetype = "locatelastlayer";
  vectorlastLayer.dhlayertype = "locatelastlayer";
  map.addLayer(vectorlastLayer);
  vectorlastSource.on("addfeature", function (e) {
    flash(map, e.feature);
  });
}
export function addMarksByOverlay(map, id, src, points) {
  let aa = document.getElementById(id);
  let lyr = new Overlay({
    id: id,
    position: [0, 0], //默认空
    positioning: "center-bottom",
    element: aa, //绑定上面添加的元素
    //stopEvent: false,
    offset: [-13.5, -40] //图片偏移量
  });
  var img = new Image();
  img.src = src;
  img.width = 35;
  aa.append(img)
  var src = src; //拼接图片地址
  // aa.style.backgroundImage = "url(" + src + ")";
  // aa.style.background="#ff0000"
  lyr.setPosition(points); //显示  
  map.addOverlay(lyr);
  // map.addOverlay(lyr)
}
/**
 * 删除图层（除了底图之外的所有业务图层）
 */
export function removeAllLayersExceptBaseMap(map) {
  var dellayers = []
  map.getLayers().getArray().forEach(layer => {
    if (layer.dhlayertype != type_googlemap) {
      dellayers.push(layer)
    }
  });
  dellayers.forEach(layer => {
    map.removeLayer(layer)
  });
}
export function removeAllLayers(map) {
  var dellayers = []
  map.getLayers().getArray().forEach(layer => {

    dellayers.push(layer)
  });
  dellayers.forEach(layer => {
    map.removeLayer(layer)
  });
}
/**
 * 根据类型获取图层（Type是在五个一控制台配置图层的资源类型code）
 */
export function getLayerByType(map, type) {
  var layers = map.getLayers().getArray();
  for (var i = 0; i < layers.length; i++) {
    if (layers[i].dhlayertype == type) {

      return layers[i]
    }
  }
  return null
}
/**
 * 根据ID获取图层
 */
export function getLayerByID(map, id) {
  var layers = map.getLayers().getArray();
  for (var i = 0; i < layers.length; i++) {
    if (layers[i].dhid == id) {
      return layers[i]
    }
  }
  return null
}
/**
 * 获取专门用于定位的图层
 */
export function getLocateLayer(map) {
  return getLayerByType(map, 'locatelayer')
}

/**
 * 从GIS配置中提取图层控制器组件用到的图层组和图层树结构信息
 * sourceFormat=vantTreeSelecter 时共用给Vant的多级选择组件使用
 * sourceFormat=vantSelect 给Vant普通下拉框提供数据源
 * sourceFormat=iviewTree 给Web端的tree空间提供数据源
 */
export function getLayerTree(gisConfig, sourceFormat,hiddenLayer) {
  var treeedata = {
    rows: [],
    selecetd: []
  };
  if (sourceFormat == 'vantTreeSelecter') {
    if (gisConfig && gisConfig.gisConfigList && gisConfig.gisConfigList.length > 0) {
      for (var i = 0; i < gisConfig.gisConfigList.length; i++) {
        var item = gisConfig.gisConfigList[i]
        var treeitem = {
          id: item.id,
          text: item.layerName,
          children: []
        }
        //遍历图层
        var zqadd = false,
          zrqadd = false
        if (item.subConfigList && item.subConfigList.length > 0) {
          for (var j = 0; j < item.subConfigList.length; j++) {
            var subitem = item.subConfigList[j];
            if(hiddenLayer && hiddenLayer.indexOf(subitem.layerType)!=-1){
              continue;
            }
            if (subitem.layerType == 'geo_sheng' || subitem.layerType == 'geo_shi' ||
              subitem.layerType == 'geo_xian' || subitem.layerType == 'geo_xiang' || subitem.layerType == 'geo_cun') {
              if (zqadd == false) {
                treeitem.children.push({
                  id: subitem.id,
                  text: '政区',
                  type: 'zq'
                })
                zqadd = true
                if (subitem.isShow == true) {
                  treeedata.selecetd.push(subitem.id)
                }
              }
              continue
            }
            if (subitem.layerType == 'geo_grid_sheng' || subitem.layerType == 'geo_grid_shi' ||
              subitem.layerType == 'geo_grid_xian' || subitem.layerType == 'geo_grid_xiang' || subitem.layerType == 'geo_grid_cun') {
              if (zrqadd == false) {
                treeitem.children.push({
                  id: subitem.id,
                  text: '责任区',
                  type: 'zrq'
                })
                zrqadd = true
                if (subitem.isShow == true) {
                  treeedata.selecetd.push(subitem.id)
                }
              }
              continue
            }
            treeitem.children.push({
              id: subitem.id,
              text: subitem.layerName,
              type: subitem.layerType || subitem.serviceType
            })
            if (subitem.isShow == true) {
              treeedata.selecetd.push(subitem.id)
            }
          }
        }
        treeedata.rows.push(treeitem)
      }
    }
  } else if (sourceFormat == 'vantSelect') {
    if (gisConfig && gisConfig.gisConfigList && gisConfig.gisConfigList.length > 0) {
      for (var i = 0; i < gisConfig.gisConfigList.length; i++) {
        var item = gisConfig.gisConfigList[i]
        var treeitem = {
          id: item.id,
          value: item.id,
          text: item.layerName,
          label: item.layerName,
          children: []
        }
        var zqadd = false
        if (item.subConfigList && item.subConfigList.length > 0) {
          for (var j = 0; j < item.subConfigList.length; j++) {
            var subitem = item.subConfigList[j]
            if(hiddenLayer && hiddenLayer.indexOf(subitem.layerType)!=-1){
              continue;
            }
            if (
              subitem.layerType == "geo_sheng" ||
              subitem.layerType == "geo_shi" ||
              subitem.layerType == "geo_xian" ||
              subitem.layerType == "geo_xiang" ||
              subitem.layerType == "geo_cun"||
              subitem.layerType == "geo_grid_sheng" ||
              subitem.layerType == "geo_grid_shi" ||
              subitem.layerType == "geo_grid_xian" ||
              subitem.layerType == "geo_grid_xiang" ||
              subitem.layerType == "geo_grid_cun"
            ) {
              let layerType=subitem.layerType || subitem.serviceType;
              let type=layerType.replace('_grid','');
              console.log(subitem.layerType,type,'type11')
              let isexist=treeitem.children.find(item => {return item.type == type})
              if(!isexist ){
                let name=type=='geo_sheng'?'省级责任区':type=='geo_shi'?
                '市级责任区':type=='geo_xian'?'县级责任区':type=='geo_xiang'?
                '乡级责任区':'村级责任区';
                treeitem.children.push({
                  id: subitem.id,
                  value: subitem.id,
                  text: name,
                  label: name,
                  type: type,
                });
              }
            }else{
              treeitem.children.push({
                id: subitem.id,
                value: subitem.id,
                text: subitem.layerName,
                label: subitem.layerName,
                type: subitem.layerType || subitem.serviceType
              })
            }
            // if (subitem.layerType == 'geo_sheng' || subitem.layerType == 'geo_shi' ||
            //   subitem.layerType == 'geo_xian' || subitem.layerType == 'geo_xiang' || subitem.layerType == 'geo_cun') {
            //   if (zqadd == false) {
            //     treeitem.children.push({
            //       id: subitem.id,
            //       value: 'zq',
            //       text: '政区',
            //       label: '政区',
            //       title: '政区',
            //       type: 'zq'
            //     })
            //     zqadd = true
            //   }
            //   continue
            // }

            // treeitem.children.push({
            //   id: subitem.id,
            //   value: subitem.id,
            //   text: subitem.layerName,
            //   label: subitem.layerName,
            //   type: subitem.layerType || subitem.serviceType
            // })
          }
        }
        treeedata.rows.push(treeitem)
      }
    }
  } else if (sourceFormat == 'iviewTree') {
    if (gisConfig && gisConfig.gisConfigList && gisConfig.gisConfigList.length > 0) {
      for (var i = 0; i < gisConfig.gisConfigList.length; i++) {
        var item = gisConfig.gisConfigList[i]
        var treeitem = {
          id: item.id,
          title: item.layerName,
          children: [],
          expand: true
        }
        //遍历图层
        var zqadd = false,
          zrqadd = false
        if (item.subConfigList && item.subConfigList.length > 0) {
          for (var j = 0; j < item.subConfigList.length; j++) {
            var subitem = item.subConfigList[j]
            if(hiddenLayer && hiddenLayer.indexOf(subitem.layerType)!=-1){
              continue;
            }
            if (subitem.layerType == 'geo_sheng' || subitem.layerType == 'geo_shi' ||
              subitem.layerType == 'geo_xian' || subitem.layerType == 'geo_xiang' || subitem.layerType == 'geo_cun') {
              if (zqadd == false) {
                treeitem.children.push({
                  id: subitem.id,
                  title: '政区',
                  type: 'zq',
                  checked: subitem.isShow
                })
                zqadd = true
              }
              continue
            }
            if (subitem.layerType == 'geo_grid_sheng' || subitem.layerType == 'geo_grid_shi' ||
              subitem.layerType == 'geo_grid_xian' || subitem.layerType == 'geo_grid_xiang' || subitem.layerType == 'geo_grid_cun') {
              if (zrqadd == false) {
                treeitem.children.push({
                  id: subitem.id,
                  title: '责任区',
                  type: 'zrq',
                  checked: subitem.isShow
                })
                zrqadd = true
              }
              continue
            }
            treeitem.children.push({
              id: subitem.id,
              title: subitem.layerName,
              type: subitem.layerType || subitem.serviceType,
              checked: subitem.isShow
            })
          }
        }
        treeedata.rows.push(treeitem)
      }
    }
  }
  return treeedata
}

/**
 * 渲染图层
 */
export function actRenderLayer(map, layerType, rendertype) {
  var layer = getLayerByType(map, layerType)
  if (layer) {
    layer.setSource(new TileWMS({
      url: layer.dhgsurl + layer.dhgsws + "/wms",
      params: {
        'LAYERS': layer.dhgsws + ":" + layer.dhgslayer,
        'TILED': true,
        'CQL_FILTER': layer.CQL_FILTER,
        STYLES: rendertype
      },
      tileGrid: tile512
    }))
  }
}


/**
 * 刷新VectorLayer(WFS)
 */
export function actRefreshLayer(map, layerType) {
  var layer = getLayerByType(map, layerType)
  if (layer) {
    layer.setSource(new VectorSource({
      format: new GeoJSON(),
      url: function (extent) {
        return layer.dhgsurl + 'wfs?service=WFS&' +
          'version=1.1.0&request=GetFeature&typename=' + layer.dhgsws + ':' + layer.dhgslayer + '&' +
          'outputFormat=application/json&srsname=' + mapConfig.projection + '&' +
          'bbox=' + extent.join(',') + ',' + mapConfig.projection;
      },
      strategy: bboxStrategy
    }))
  }
}

/**
 * 刷新TileLayer（WMS）
 */

var refreshCount = 1
export function actRefreshTileLayer(map, layerType) {
  var stem = Math.floor((Math.random() * 100000) + 1);
  var layer = getLayerByType(map, layerType)
  if (layer) {
    if (!layer.CQL_FILTER) {
      layer.CQL_FILTER = stem + '=' + stem
    } else {
      layer.CQL_FILTER = layer.CQL_FILTER + " and " + stem + '=' + stem
    }
    layer.setSource(new TileWMS({
      url: layer.dhgsurl + layer.dhgsws + "/wms",
      params: {
        'LAYERS': layer.dhgsws + ":" + layer.dhgslayer,
        'TILED': true,
        'CQL_FILTER': layer.CQL_FILTER
      },
      tileGrid: tile512
    }))
  }
}

/**
 * 显示隐藏图层
 */
export function actTroggleLayer(map, layerType, _v) {
  if (layerType == 'zq') {
    var zqlayers = ['geo_sheng', 'geo_shi', 'geo_xian', 'geo_xiang', 'geo_cun']
    var isVisible = false
    for (var lidx in zqlayers) {
      var layer = getLayerByType(map, zqlayers[lidx])
      if (layer) {
        isVisible = typeof (_v) === 'undefined' ? !layer.getVisible() : _v
        layer.setVisible(isVisible)
      }
    }
    var zrqlayers = ['geo_grid_sheng', 'geo_grid_shi', 'geo_grid_xian', 'geo_grid_xiang', 'geo_grid_cun']
    for (var lidx in zrqlayers) {
      var _style = isVisible ? zrqlayers[lidx] + "_nolabel" : zrqlayers[lidx];
      var layer = getLayerByType(map, zrqlayers[lidx])
      if (layer) {
        layer.setSource(new TileWMS({
          url: layer.dhgsurl + layer.dhgsws + "/wms",
          params: {
            'LAYERS': layer.dhgsws + ":" + layer.dhgslayer,
            'TILED': true,
            'CQL_FILTER': layer.CQL_FILTER,
            STYLES: _style
          },
          tileGrid: tile512
        }))
      }
    }
  } else if (layerType == 'zrq') {
    var zrqlayers = ['geo_grid_sheng', 'geo_grid_shi', 'geo_grid_xian', 'geo_grid_xiang', 'geo_grid_cun']
    for (var lidx in zrqlayers) {
      var layer = getLayerByType(map, zrqlayers[lidx])
      if (layer) {
        layer.setVisible(typeof (_v) === 'undefined' ? !layer.getVisible() : _v)
      }
    }
  } else {
    var layer = getLayerByType(map, layerType)
    console.log(layerType, layer.getVisible())
    if (layer) {
      layer.setVisible(typeof (_v) === 'undefined' ? !layer.getVisible() : _v)
    }
  }
}

/**
 * 根据坐标和图层自动查询并返回该图层符合的对象
 * isAll,为true是返回所有数据，false只返回一个
 *  * isCommand针对于指挥中心的
 */
export function actLocateByCoordinate(map, coordinate, layerType, callback, dontShowMSG, mutiselect,isAll,isCommand) {
  var currentLayer = getLayerByType(map, layerType)
  if(layerType=='lz_user' || layerType=='v_lz'){
    layerType='v_lz'
  }
  if(isCommand){//指挥中心的，
    if(layerType== "geo_sheng" ||layerType == "geo_shi" ||
      layerType == "geo_xian" ||layerType == "geo_xiang" ||layerType == "geo_cun"){
        var commandType=layerType;
        layerType=layerType.slice(0, 3) + '_grid' + layerType.slice(3);
        currentLayer = getLayerByType(map, layerType);  
    }
  }
  //有些图层因为是系统自带的，并且没有配置在总控制台中，需要从配置中获取
  if (!currentLayer) {
    for (var i = 0; i < mapConfig.excludeLayers.length; i++) {
      if (mapConfig.excludeLayers[i].dhlayertype == type) {
        currentLayer = mapConfig.excludeLayers[i]
        currentLayer.dhservicetype = type_geoserverwms
        currentLayer.dhgslayer = type
        currentLayer.dhgsurl = map.gisConfig.geoServerUrl //mapConfig.defaultGeoServerURL
        currentLayer.dhgsws = map.gisConfig.geoServerWorkspace //mapConfig.defaultGeoServerWorkspace
        break
      }
    }
  }
  //如果该图层是wfs，先动态创建一个wms图层，仅用于wms查询
  if (currentLayer.getSource().constructor === VectorSource) {
    currentLayer = new TileLayer({
      source: new TileWMS({
        url: currentLayer.dhgsurl + currentLayer.dhgsws + "/wms",
        params: {
          'LAYERS': currentLayer.dhgsws + ":" + layerType,
          'TILED': true,
        },
        tileGrid: tile512
      })
    })
  }
  if (currentLayer) {
    var viewResolution = /** @type {number} */ (map.getView().getResolution());
    var url = currentLayer.getSource().getGetFeatureInfoUrl(coordinate, viewResolution, mapConfig.projection, {
      'INFO_FORMAT': 'application/json'
    });
    if (url) {
      fetch(url).then(function (response) {
        return response.json();
      }).then(function (geojsonObject) {
        try {
          var vectorSource = getLocateLayer(map).getSource()
          if (!mutiselect) {
            vectorSource.clear()
            map.getOverlays().clear()
          }
          var features = (new GeoJSON()).readFeatures(geojsonObject);
          var target = features[0];
          if (target) {
            target.dhfeaturetype = layerType;
            vectorSource.addFeature(target);
          } else {
            if(isCommand){
              actLocateByCoordinate(
                map, coordinate, commandType, callback, dontShowMSG, mutiselect,isAll,
                false
              )
              return
            }
            if (!dontShowMSG) {
              mapalert('未查询到资源')
            }
          }
          if (callback) {
            callback(isAll?features:target);
          }
        } catch (e) {}
      });
    }
  }
}


export function actClearFeature(map) {
  var vl = getLocateLayer(map);
  if (vl && vl.getSource()) {
    vl.getSource().clear()
  }
}
export function actLocateOne(map, type, objid, vectorlayer, callback, dontShowMSG, fnValidata) {
  if (map && type && objid) {
    //先根据type获取图层，如果为空再去excludeLyaers里面找一下（因为有些图层因为业务原因是不用显示在地图上的，但是定位会用到）
    var targetLayer = getLayerByType(map, type)
    
    if (!targetLayer) {
      for (var i = 0; i < mapConfig.excludeLayers.length; i++) {
        if (mapConfig.excludeLayers[i].dhlayertype == type && type != 'geo_gushu') {
          targetLayer = mapConfig.excludeLayers[i]
          targetLayer.dhservicetype = type_geoserverwms
          targetLayer.dhgslayer = type
          targetLayer.dhgsurl = map.gisConfig.geoServerUrl //mapConfig.defaultGeoServerURL
          targetLayer.dhgsws = map.gisConfig.geoServerWorkspace //mapConfig.defaultGeoServerWorkspace
          break
        }
      }
    }
    //任务图层是个比较特殊的wfs图层，在服务端配置了cql，所以定位时需要使用未配置cql的那个图层（否则无法定位已办结或已忽略的任务）
    var layername = targetLayer.dhgslayer
    var vectorSource = new VectorSource();
    var layeritem = new VectorLayer({
      source: vectorSource,
      visible:true,
         // minResolution:1,
         // maxResolution:targetLayer.dhmaxzoom,
      style: wfsStyleFunction
    })
   
    layeritem.dhgsurl = targetLayer.dhgsurl
     layeritem.dhgsws = targetLayer.dhgsws
     layeritem.dhgslayer = targetLayer.dhgslayer
     layeritem.dhlayername = '22222'
     layeritem.dhservicetype = targetLayer.dhservicetype
     layeritem.dhlayertype = targetLayer.dhlayertype
     layeritem.dhid = targetLayer.dhid
     layeritem.dhminzoom = targetLayer.dhminzoom
     layeritem.dhmaxzoom = targetLayer.dhmaxzoom
     layeritem.CQL_FILTER = targetLayer.CQL_FILTER
     map.addLayer(layeritem)
    if (type == 'lz_task' && layername=='lz_task') {
      layername += '_locate'
    }
    let filter = '';
    if (type == 'geo_gushu') {
      filter = equalToFilter("id", objid)
    } else {
      filter = equalToFilter("objid", objid)
    }
    //空间查询
    fetch(targetLayer.dhgsurl + "wfs", {
        method: 'POST',
        body: new XMLSerializer().serializeToString(
          new WFS().writeGetFeature({
            srsName: mapConfig.projection,
            featureNS: targetLayer.dhgsurl + targetLayer.dhgsws,
            featurePrefix: targetLayer.dhgsws,
            featureTypes: [layername],
            outputFormat: 'application/json',
            maxFeatures: 1,
            filter: filter
          })
        ),
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var features = new GeoJSON().readFeatures(data);

        var target = features[0];
        target.dhfeaturetype=type;
        if (target && target.getGeometry()) {
          //如果需要条件验证，在此统一检测
          if (fnValidata) {
            if (!fnValidata(target)) {
              return
            }
          }
          //把查询出的要素添加到图层
        //   target.dhfeaturetype = type;

         vectorSource.addFeature(target);
         
        } else {
          if (!dontShowMSG) {
            mapalert('未找到位置信息！')
          }
        }
        if (callback) {
          callback(target)
        }
      })
  }
}
/**
 * 通用定位
 * vectorlayer 为空时，用地图全局共用的VectorLayer进行定位
 * callback 是回调函数
 * fnValidata 是验证函数，当返回false，说明验证不通过，则不进行定位
 */
export function actLocate(map, type, objid, vectorlayer, callback, dontShowMSG, fnValidata) {
  if (map && type && objid) {
    //先根据type获取图层，如果为空再去excludeLyaers里面找一下（因为有些图层因为业务原因是不用显示在地图上的，但是定位会用到）
    var targetLayer = getLayerByType(map, type) 
    if (!targetLayer) {
      for (var i = 0; i < mapConfig.excludeLayers.length; i++) {
        if (mapConfig.excludeLayers[i].dhlayertype == type && type != 'geo_gushu') {
          targetLayer = mapConfig.excludeLayers[i]
          targetLayer.dhservicetype = type_geoserverwms
          targetLayer.dhgslayer = type
          targetLayer.dhgsurl = map.gisConfig.geoServerUrl //mapConfig.defaultGeoServerURL
          targetLayer.dhgsws = map.gisConfig.geoServerWorkspace //mapConfig.defaultGeoServerWorkspace
          break
        }
      }
    }
    //任务图层是个比较特殊的wfs图层，在服务端配置了cql，所以定位时需要使用未配置cql的那个图层（否则无法定位已办结或已忽略的任务）
    var layername = targetLayer.dhgslayer

    if (type == 'lz_task' && layername=='lz_task') {
      layername += '_locate'
    }
    let filter = '';
    if (type == 'geo_gushu') {
      filter = equalToFilter("id", objid)
    } else {
      filter = equalToFilter("objid", objid)
    }
    //空间查询
    fetch(targetLayer.dhgsurl + "wfs", {
        method: 'POST',
        body: new XMLSerializer().serializeToString(
          new WFS().writeGetFeature({
            srsName: mapConfig.projection,
            featureNS: targetLayer.dhgsurl + targetLayer.dhgsws,
            featurePrefix: targetLayer.dhgsws,
            featureTypes: [layername],
            outputFormat: 'application/json',
            maxFeatures: 1,
            filter: filter
          })
        ),
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var vectorSource = null;
        if (vectorlayer) {
          vectorSource = vectorlayer.getSource()
        } else {
          vectorSource = getLocateLayer(map).getSource()
        }
        vectorSource.clear()
        map.getOverlays().clear()
        var features = new GeoJSON().readFeatures(data);
        var target = features[0];
        if (target && target.getGeometry()) {
          //如果需要条件验证，在此统一检测
          if (fnValidata) {
            if (!fnValidata(target)) {
              return
            }
          }
          //把查询出的要素添加到图层
          target.dhfeaturetype = type;
          vectorSource.addFeature(target);
          
          if (target.getGeometry().constructor != Point && (type == 'lz_protect_forest' || type == 'xl')) {
            let firstCoordinate = target.getGeometry().getFirstCoordinate();
            let lastCoordinate = target.getGeometry().getLastCoordinate();
            addMarksByOverlay(map, 'marker1', baseUrl + 'start.gif', firstCoordinate)
            addMarksByOverlay(map, 'marker2', baseUrl + 'end.gif', lastCoordinate)
            let firstFeature = new Feature();
            firstFeature.setGeometry(new Point(firstCoordinate));
            firstFeature.setStyle(locateStyleCollection["locate_first"])
            let firstPoint = firstFeature.clone();
            firstPoint.setStyle(locateStyleCollection["locate_point"])

            var vectorlastLayer = getLayerByType(map, 'locatelastlayer')
            let vectorlastSource = vectorlastLayer.getSource();
            let lastFeature = new Feature();
            lastFeature.setGeometry(new Point(lastCoordinate));
            lastFeature.setStyle(locateStyleCollection["locate_last"])
            let lastPoint = lastFeature.clone();
            lastPoint.setStyle(locateStyleCollection["locate_point"])

            vectorlastSource.addFeature(lastPoint)
            // vectorlastSource.addFeature(lastFeature)
            let vectorfirstLayer = getLayerByType(map, 'locatefirstlayer')
            // console.log('locatelLayer','locatel')
            let vectorfirstSource = vectorfirstLayer.getSource();
            vectorfirstSource.addFeature(firstPoint)
            // vectorfirstSource.addFeature(firstFeature)
          }
          //定位到新添加的要素
          if (target.getGeometry().constructor === Point) {
            map.getView().setZoom(parseInt(targetLayer.dhminzoom) + 1);
            map.getView().setCenter(target.getGeometry().getFirstCoordinate());
          } else {
            // map.getView().setCenter(target.getGeometry().getLastCoordinate());
            map.getView().fit(vectorSource.getExtent());

          }
        } else {
          if (!dontShowMSG) {
            mapalert('未找到位置信息！')
          }
        }
        if (callback) {
          callback(target)
        }
      })
  }
}


/**
 * 地图默认配置对象（地图接口如果取不到数据，默认以这个配置对象参数展示地图）
 */
export const mapConfig = {
  projection: "EPSG:4326",
  initscale: 7,
  minscale: 1,
  maxscale: 18,
  center: [115.8014, 31.4882],
  excludeLayers: [
    //一些不用发布在地图上显示，但功能上可能需要进行定位的数据在这里配置定位需要的参数（巡林、发现）
    {
      dhlayertype: 'lz_protect_forest',
      dhminzoom: 12
    },
    {
      dhlayertype: 'sys_discover',
      dhminzoom: 12
    },
    {
      dhlayertype: 'geo_demonstration_area',
      dhminzoom: 12
    }
  ],
  render: [{
      text: '林地',
      children: [{
          text: '无渲染',
          title: '无渲染',
          id: 'geo_xiaoban',
          type: 'geo_xiaoban',
          checked: "true"
        },
        {
          text: '按地类',
          title: '按地类',
          id: 'geo_xiaoban_dl',
          type: 'geo_xiaoban'
        },
        {
          text: '按森林类别',
          title: '按森林类别',
          id: 'geo_xiaoban_sllb',
          type: 'geo_xiaoban'
        },
        {
          text: '按事权等级',
          title: '按事权等级',
          id: 'geo_xiaoban_sqdj',
          type: 'geo_xiaoban'
        },
        {
          text: '林地保护等级',
          title: '林地保护等级',
          id: 'geo_xiaoban_bhdj',
          type: 'geo_xiaoban'
        },
        {
          text: '按主体功能区',
          title: '按主体功能区',
          id: 'geo_xiaoban_ztgnq',
          type: 'geo_xiaoban'
        },
        {
          text: '林地管理部门',
          title: '林地管理部门',
          id: 'geo_xiaoban_glbm',
          type: 'geo_xiaoban'
        }
      ]
    },
    {
      text: '湿地',
      children: [{
          text: '无渲染',
          title: '无渲染',
          id: 'geo_shidi',
          type: 'geo_shidi',
          checked: "true"
        },
        {
          text: '按湿地类',
          title: '按湿地类',
          id: 'geo_shidi_dl',
          type: 'geo_shidi'
        }
      ]
    },
    {
      text: '自然保护地',
      children: [{
          text: '无渲染',
          title: '无渲染',
          id: 'geo_baohudi',
          type: 'geo_baohudi',
          checked: "true"
        },
        {
          text: '按类型',
          title: '按类型',
          id: 'geo_baohudi_lx',
          type: 'geo_baohudi'
        }
      ]
    }
  ],
  symbol: [{
      groupName: '监测管理',
      groupItems: [{
        title: '',
        symbols: [{
            name: '任务（上报）',
            icon: iconTaskUp,
            type: 'icon'
          },
          {
            name: '任务（下发）',
            icon: iconTaskDown,
            type: 'icon'
          },
          {
            name: '人员',
            icon: iconUser,
            type: 'icon'
          },
          {
            name: '古树（一级）',
            icon: tree1,
            type: 'icon'
          },
          {
            name: '古树（二级）',
            icon: tree2,
            type: 'icon'
          },
          {
            name: '古树（三级）',
            icon: tree3,
            type: 'icon'
          },
          {
            name: '古树（名木）',
            icon: tree4,
            type: 'icon'
          },
          {
            name: '公示牌',
            icon: gsp,
            type: 'icon'
          },
          {
            name: '监测点',
            icon: jcd,
            type: 'icon'
          },
          {
            name: '兴趣点',
            icon: xqd,
            type: 'icon'
          }
        ]
      }]
    },
    {
      groupName: '政区网格',
      groupItems: [{
          title: '政区',
          symbols: [{
              name: '省界(2.2)',
              icon: '#00e6a9',
              type: 'line',
              height: '5px'
            },
            {
              name: '市界(1.6)',
              icon: '#f5ca7a',
              type: 'line',
              height: '4px'
            },
            {
              name: '县界(1.4)',
              icon: '#e64c00',
              type: 'line',
              height: '3px'
            },
            {
              name: '乡界(1.2)',
              icon: '#e8a88a',
              type: 'line',
              height: '2px'
            },
            {
              name: '村界(1)',
              icon: '#a48cf1',
              type: 'line',
              height: '1px'
            }
          ]
        },
        {
          title: '网格（责任区）',
          symbols: [{
              name: '省级(1.6)',
              icon: '#263df2',
              type: 'line',
              height: '5px'
            },
            {
              name: '市级(1.4)',
              icon: '#263df2',
              type: 'line',
              height: '4px'
            },
            {
              name: '县级(1.2)',
              icon: '#263df2',
              type: 'line',
              height: '3px'
            },
            {
              name: '乡级(1)',
              icon: '#263df2',
              type: 'line',
              height: '2px'
            },
            {
              name: '村级(0.8)',
              icon: '#263df2',
              type: 'line',
              height: '1px'
            }
          ]
        }
      ]
    },
    {
      groupName: '林地',
      groupItems: [{
          title: '无渲染',
          symbols: [{
            name: '林地',
            icon: '#f5f57a',
            type: 'line',
            height: '2px'
          }, ]
        },
        {
          title: '按地类',
          symbols: [{
              "name": "乔木林地",
              icon: '#70a800',
              type: 'area'
            },
            {
              "name": "竹林地",
              icon: '#ffb366',
              type: 'area'
            },
            {
              "name": "疏林地",
              icon: '#ccff66',
              type: 'area'
            },
            {
              "name": "国家特别规定",
              icon: '#ccbfff',
              type: 'area'
            },
            {
              "name": "一般灌木林地",
              icon: '#ccd9ff',
              type: 'area'
            },
            {
              "name": "封山育林未成",
              icon: '#bfd980',
              type: 'area'
            },
            {
              "name": "苗圃地",
              icon: '#73ff33',
              type: 'area'
            },
            {
              "name": "采伐迹地",
              icon: '#ff99b3',
              type: 'area'
            },
            {
              "name": "火烧迹地",
              icon: '#ffbee8',
              type: 'area'
            },
            {
              "name": "其他无立木林",
              icon: '#f57ab6',
              type: 'area'
            },
            {
              "name": "临时占用",
              icon: '#7f4465',
              type: 'area'
            },
            {
              "name": "宜林地",
              icon: '#ffff00',
              type: 'area'
            },
            {
              "name": "林业生产辅助",
              icon: '#d7c29e',
              type: 'area'
            }
          ]
        },
        {
          title: '按森林类别',
          symbols: [{
              "name": "重点公益林",
              icon: '#70a800',
              type: 'area'
            },
            {
              "name": "地方公益林",
              icon: '#bfd980',
              type: 'area'
            },
            {
              "name": "重点商品林",
              icon: '#ffb366',
              type: 'area'
            },
            {
              "name": "一般商品林",
              icon: '#ccd9ff',
              type: 'area'
            }
          ]
        },
        {
          title: '按事权等级',
          symbols: [{
              "name": "国家级公益林",
              icon: '#70a800',
              type: 'area'
            },
            {
              "name": "省级公益林",
              icon: '#ffb366',
              type: 'area'
            },
            {
              "name": "地方公益林",
              icon: '#ccff66',
              type: 'area'
            }
          ]
        },
        {
          title: '按保护等级',
          symbols: [{
              "name": "Ⅰ级保护林地",
              icon: '#70a800',
              type: 'area'
            },
            {
              "name": "Ⅱ级保护林地",
              icon: '#bfd980',
              type: 'area'
            },
            {
              "name": "Ⅲ级保护林地",
              icon: '#ccd9ff',
              type: 'area'
            },
            {
              "name": "Ⅳ级保护林地",
              icon: '#66cdab',
              type: 'area'
            }
          ]
        },
        {
          title: '按主体功能区',
          symbols: [{
              "name": "优化开发区",
              icon: '#70a800',
              type: 'area'
            },
            {
              "name": "重点开发区",
              icon: '#bfd980',
              type: 'area'
            },
            {
              "name": "限制开发区",
              icon: '#ffd37f',
              type: 'area'
            },
            {
              "name": "禁止开发区",
              icon: '#ff0000',
              type: 'area'
            }
          ]
        },
        {
          title: '按管理部门',
          symbols: [{
              "name": "林业部门管理",
              icon: '#70a800',
              type: 'area'
            },
            {
              "name": "非林业部门管",
              icon: '#ffb366',
              type: 'area'
            },
            {
              "name": "不确定",
              icon: '#66cdab',
              type: 'area'
            }
          ]
        }
      ]
    },
    {
      groupName: '湿地',
      groupItems: [{
          title: '无渲染',
          symbols: [{
            name: '湿地',
            icon: '#7ec1e0',
            type: 'area'
          }, ]
        },
        {
          title: '按湿地类',
          symbols: [{
              "name": "湖泊湿地",
              icon: '#73b2ff',
              type: 'area'
            },
            {
              "name": "人工湿地",
              icon: '#00a9e6',
              type: 'area'
            },
            {
              "name": "沼泽湿地",
              icon: '#bed2ff',
              type: 'area'
            },
            {
              "name": "河流湿地",
              icon: '#97dbf2',
              type: 'area'
            },
            {
              "name": "滨海湿地",
              icon: '#bee8ff',
              type: 'area'
            }
          ]
        }
      ]
    },
    {
      groupName: '自然保护地',
      groupItems: [{
          title: '无渲染',
          symbols: [{
            name: '自然保护地',
            icon: '#74a474',
            type: 'area'
          }, ]
        },
        {
          title: '按地类',
          symbols: [{
              "name": "国家公园",
              icon: '#cd6699',
              type: 'area'
            },
            {
              "name": "自然保护区",
              icon: '#ffa77f',
              type: 'area'
            },
            {
              "name": "湿地公园",
              icon: '#73b273',
              type: 'area'
            },
            {
              "name": "森林公园",
              icon: '#0070ff',
              type: 'area'
            },
            {
              "name": "其他自然公园",
              icon: '#ffff73',
              type: 'area'
            }
          ]
        }
      ]
    }
  ]
}

//=================统一提示方法=====================
//原则上GIS组件不跟UI打交道，但是有些时候需要输出一些提示信息（需要兼容Web和H5两端）
export function mapalert(msg) {
  if (vm.$Message) {
    vm.$Message.error(msg)
  } else {
    vm.$toast(msg)
  }
}
//=================定位时动画效果函数=====================
function flash(map, feature) {
  var duration = 666;
  var start = new Date().getTime();
  var listenerKey = map.on('postcompose', animate);

  function animate(event) {
    try {
      var vectorContext = event.vectorContext;
      var frameState = event.frameState;
      var flashGeom = feature.getGeometry().clone();
      var elapsed = frameState.time - start;
      var elapsedRatio = elapsed / duration;
      // console.log(elapsedRatio);
      var radius = easeOut(elapsedRatio) * 25 + 5;
      var opacity = easeOut(1 - elapsedRatio);

      var style = new Style({
        image: new CircleStyle({
          radius: radius,
          stroke: new Stroke({
            color: 'rgba(45, 255, 254, ' + opacity + ')',
            width: 1.5 + opacity
          })
        })
      });
      vectorContext.setStyle(style);
      vectorContext.drawGeometry(flashGeom);
      if (elapsed > duration) {
        unByKey(listenerKey);
        return;
      }
      map.render();
    } catch (e) {}
  }
}